import { render, staticRenderFns } from "./JobPreviewMainArticle.vue?vue&type=template&id=7d2e58a6&scoped=true"
import script from "./JobPreviewMainArticle.vue?vue&type=script&lang=js"
export * from "./JobPreviewMainArticle.vue?vue&type=script&lang=js"
import style0 from "./JobPreviewMainArticle.vue?vue&type=style&index=0&id=7d2e58a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2e58a6",
  null
  
)

export default component.exports